/* ABC: превью цветов в карточке товара разбиваются на РОВНЫЕ ряды.
   Было: сколько влезло в строку, остальное падает вниз — при 8 цветах
   получалось 7 + 1, что выглядит нелепо.
   Стало: если всё влезает в одну строку — одна строка; если нет —
   делим поровну. 8 → 4+4, 7 → 4+3 (когда не влезает), 10 → 5+5. */
(function () {
  function layout(box) {
    var items = Array.from(box.children).filter(function (c) {
      return c.getBoundingClientRect().width > 0;
    });
    var n = items.length;
    if (n < 2) return;

    var cs = getComputedStyle(box);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    var item = items[0].getBoundingClientRect().width;
    if (!item) return;

    /* доступная ширина без учёта уже заданного нами ограничения */
    box.style.maxWidth = '';
    var avail = box.getBoundingClientRect().width;

    var maxFit = Math.max(1, Math.floor((avail + gap) / (item + gap)));
    if (n <= maxFit) { box.style.maxWidth = ''; box.style.marginInline = ''; return; }

    var rows = Math.ceil(n / maxFit);
    var perRow = Math.ceil(n / rows);
    /* ограничиваем ширину так, чтобы перенос случился ровно после perRow */
    box.style.maxWidth = (perRow * item + (perRow - 1) * gap) + 'px';
    /* суженный блок надо вернуть в центр колонки, иначе он прижимается влево */
    box.style.marginInline = 'auto';
  }

  function scan() {
    /* в карточке товара — одна строка на ПК и телефоне (владелец, 22.09), ряды не делим */
    document.querySelectorAll('.abc-colors:not(.product-details .abc-colors)').forEach(layout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
  window.addEventListener('resize', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ABC: телефон и ПК — цвета одной строкой. Если не влезают: строка листается,
   края тают (классы is-overflow / is-scrolled / is-end), текущий цвет
   сразу прокручен в видимую часть. */
(function () {
  var mq = window.matchMedia('(min-width: 0px)');
  function edges(box) {
    var over = mq.matches && box.scrollWidth > box.clientWidth + 1;
    box.classList.toggle('is-overflow', over);
    box.classList.toggle('is-scrolled', over && box.scrollLeft > 2);
    box.classList.toggle('is-end', over && box.scrollLeft + box.clientWidth >= box.scrollWidth - 2);
  }
  function setup(box) {
    if (box.dataset.abcRow) { edges(box); return; }
    box.dataset.abcRow = '1';
    box.addEventListener('scroll', function () { edges(box); }, { passive: true });
    edges(box);
    var cur = box.querySelector('.is-current');
    if (cur && box.classList.contains('is-overflow')) {
      box.scrollLeft = Math.max(0, cur.offsetLeft - (box.clientWidth - cur.offsetWidth) / 2);
      edges(box);
    }
  }
  function all() { document.querySelectorAll('.product-details .abc-colors').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  window.addEventListener('resize', all);
  mq.addEventListener && mq.addEventListener('change', all);
})();
